import script from "./BoArd.vue?vue&type=script&setup=true&lang=js"
export * from "./BoArd.vue?vue&type=script&setup=true&lang=js"

import "./BoArd.vue?vue&type=style&index=0&id=41888f33&lang=css"
import "./BoArd.vue?vue&type=style&index=1&id=41888f33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41888f33"]])

export default __exports__